/**
 * 免费档自助绑定（free-onboarding）。填小程序 appid + AppSecret 自助开免费档。
 * 跟 fabric-server::routes::onboarding 对齐。
 */
import { apiRequest } from './client'

export interface FreeBindRequest {
  appid: string
  app_secret: string
  /** 新建时必填(重绑已存在 appid 时可省) */
  shop_name?: string
  phone?: string
}

export interface FreeBindResponse {
  token: string
  tenant_ulid: string
  is_new: boolean
}

export function freeBind(req: FreeBindRequest): Promise<FreeBindResponse> {
  return apiRequest<FreeBindResponse>('/onboarding/free-bind', {
    method: 'POST',
    jsonBody: req,
    // 自助开通是 pre-auth 流程,其 4xx 交页面处理,不是"登录过期"(P1-6)。
    skipAuthRedirect: true
  })
}
